import React from "react";
import { Badge } from "reactstrap";
import "./StatusBadgeV2.scss";

// Map string statuses to class names
const statusColors: Record<string, string> = {
  sent: "sent",
  "in force": "in-force",
  issued: "issued",
  assigned: "assigned",
  unassigned: "unassigned",
  declined: "declined",
  pending: "pending",
  "app submitted": "app-submitted",
  qa: "qa",
  void: "void",
  na: "na",
  "pending with carrier": "pending-with-carrier",
  "pending with agent": "pending-with-agent",
  "pending with bga": "pending-with-bga",
  draft: "draft",
  completed: "completed",
  scheduled: "scheduled",
  inprogress: "inprogress",
  "campaigns to-send": "campaigns-to-send",
  "campaigns sent": "campaigns-sent",
  "campaigns error": "campaigns-error",
  "campaigns paused": "campaigns-paused",
};

const getStatusColor = (status: string): string => statusColors[status?.toLowerCase()] || "assigned";

interface IStatusBadgeProps {
  status: string;
  label?: string;
}

const StatusBadge: React.FC<IStatusBadgeProps> = ({ status, label }) => {
  if (!status) return null;

  const color = getStatusColor(status);

  return (
    <div>
      <Badge className={`status-badge-v2 status-badge-v2--${color}`} color={null}>
        <span>{label || status}</span>
      </Badge>
    </div>
  );
};

export default StatusBadge;
